import { Component, OnInit, Sanitizer } from '@angular/core';
import { NavParams, ModalController, Platform } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-videomodal',
    templateUrl: './videomodal.component.html',
    styleUrls: ['./videomodal.component.scss'],
    standalone: false
})
export class VideomodalComponent implements OnInit {
  // private readonly testFullscreenVideoUrl = 'https://player.vimeo.com/video/76979871?dnt=1&playsinline=1&fullscreen=1';
  private readonly defaultVimeoVideoPath = '/407508746';
  
  video: any;

  public response:any;
  public basepath:any;
  public redirecturl:any;
  public vimeolink:any;
  public showAjaxRequestLoader;
  public showSpinnerLoader;
  public timeoutIframeload: any;
  public fixedWidth: any = 380;


  constructor(public platform: Platform, public data: DataService, navParams: NavParams, public modalController: ModalController, public sanitizer: DomSanitizer) {

    // if web
  }

  ngOnInit() {
    console.log(this.video)
    this.vimeolink = this.sanitizer.bypassSecurityTrustResourceUrl(this.buildVimeoPlayerUrl());
  }

  get isMobileLayout(): boolean {
    return typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;
  }

  ionViewWillEnter(){
    this.showAjaxRequestLoader = true;
    this.timeoutIframeload = setTimeout(() => {
      this.showSpinnerLoader = true;
    },5000);
  }

  iframeLoaded(){
    clearTimeout(this.timeoutIframeload);
    this.showAjaxRequestLoader = false;
    this.showSpinnerLoader = false;
  }

  private get videoRatio(): number {
    if (this.video?.width && this.video?.height && this.video.width > 0 && this.video.height > 0) {
      return this.video.width / this.video.height;
    }
    return 16 / 9; // default: landscape 16:9
  }

  platformWidth(): number {
    const ratio = this.videoRatio;
    if (ratio >= 1) {
      // Landscape: cap at 550px, shrink on narrow screens (32px total margin)
      return Math.min(window.innerWidth - 32, 550);
    } else {
      // Portrait: derive from height
      return Math.round(this.platformHeight() * ratio);
    }
  }

  platformHeight(): number {
    const ratio = this.videoRatio;
    if (ratio >= 1) {
      // Landscape: height derived from width
      return Math.round(this.platformWidth() / ratio);
    } else {
      // Portrait: cap at available height
      return Math.min(window.innerHeight - 100, 480);
    }
  }

  vimeowidth(): number {
    return this.platformWidth();
  }

  vimeoheight(): number {
    return this.platformHeight();
  }

  get isNativeIosApp(): boolean {
    return this.platform.is('ios') && this.platform.is('hybrid');
  }

  private buildVimeoPlayerUrl(): string {
    const rawVideoPath = this.video?.vimeovideo;
    const normalizedVideoPath = rawVideoPath
      ? (rawVideoPath.startsWith('/') ? rawVideoPath : `/${rawVideoPath}`)
      : this.defaultVimeoVideoPath;
    const url = new URL(`https://player.vimeo.com/video${normalizedVideoPath}`);
    const extraParams = this.video?.extra_params;

    if (extraParams) {
      const normalizedExtraParams = extraParams.startsWith('?') || extraParams.startsWith('&')
        ? extraParams.slice(1)
        : extraParams;

      new URLSearchParams(normalizedExtraParams).forEach((value, key) => {
        url.searchParams.set(key, value);
      });
    }

    url.searchParams.set('dnt', '1');
    url.searchParams.set('playsinline', '1');
    url.searchParams.set('fullscreen', '1');

    return url.toString();
  }

  get vimeolink_(){
    // console.log('https://player.vimeo.com/video'+ this.video.vimeovideo);
    // console.log(this.video);  

    if( this.video.vimeovideo )
      return this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video'+ this.video.vimeovideo);
    else
      return this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/407508746');
    

    return this.sanitizer.bypassSecurityTrustHtml('https://player.vimeo.com/video/'+ this.video.vimeovideo);
  }

  cancel(){
    console.log(this.data.diag)
    this.modalController.dismiss();
    // this.data.rateApp();
  }
}
